<template>
  <v-input v-bind="$attrs" dense class="datetimepicker">
    <date-picker
      v-model="localValue"
      :show-second="false"
      value-type="date"
      format="YYYY-MM-DD HH:mm"
      type="datetime"
    />
  </v-input>
</template>

<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/locale/it"

export default {
  components: { DatePicker },
  props: {
    value: {
      type: [Date, String],
      default: "",
    },
    errorMessages: {
      type: [String, Array],
      default: "",
    },
  },
  computed: {
    localValue: {
      get() {
        // console.log("get", this.value)
        if (this.value) {
          return this.$parseDate(this.value)
        }
        return null
      },
      set(localValue) {
        // console.log("set", localValue)
        if (localValue) {
          this.$emit("input", this.$formatDateISO(localValue))
        } else {
          this.$emit("input", null)
        }
      },
    },
  },
}
</script>

<style lang="scss">
@import "~vue2-datepicker/scss/index.scss";

.datetimepicker label {
  font-size: 12px;
  width: 100%;
}

.datetimepicker .v-input__slot {
  flex-direction: column;
}

.mx-input-wrapper {
  width: 100%;
}

.mx-datepicker {
  align-self: flex-end;
  flex: 1 1;
  position: relative;
  width: 100%;
  left: 0;
  top: -3px;
}

.mx-input {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 16px;
  border-bottom: 1px solid #949494;
  border-radius: 0;
  width: 100%;
  box-shadow: none;
}
</style>
